import { normalizeWorkspaceMode, type WorkspaceMode } from "@spuerhund/shared/runtime";

const WORKSPACE_MODE_STORAGE_KEY = "spuerhund:workspace-mode";
const LEGACY_MODE_STORAGE_KEY = "spuerhund:mode";

export function readStoredWorkspaceMode(): WorkspaceMode {
  if (typeof window === "undefined") return "anonymous";
  const raw = window.localStorage.getItem(WORKSPACE_MODE_STORAGE_KEY)
    ?? window.localStorage.getItem(LEGACY_MODE_STORAGE_KEY);
  return normalizeWorkspaceMode(raw?.trim());
}

export function persistWorkspaceMode(mode: WorkspaceMode) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(WORKSPACE_MODE_STORAGE_KEY, mode);
  window.localStorage.removeItem(LEGACY_MODE_STORAGE_KEY);
}
